import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, MessageCircle } from "lucide-react";
import { aff, WHATSAPP_GROUP, WHATSAPP_AFFILIATE } from "../mock";

export default function Footer() {
  const cols = [
    {
      title: "Shop",
      links: [
        { label: "All Products", href: aff("/collections/all") },
        { label: "Fashion Gold", href: aff("/collections/fashion-gold") },
        { label: "Mirra", href: aff("/collections/mirra") },
        { label: "Vello", href: aff("/collections/vello-1") },
        { label: "Cronograma", href: aff("/collections/cronograma-hair-care-system") },
      ],
    },
    {
      title: "About",
      links: [
        { label: "Our Story", href: aff("/pages/our-story") },
        { label: "Journal", href: aff("/blogs/haircare") },
        { label: "Contact", href: aff("/pages/contact") },
      ],
    },
    {
      title: "Community",
      links: [
        { label: "Join WhatsApp Group", href: WHATSAPP_GROUP },
        { label: "Become an Affiliate", href: WHATSAPP_AFFILIATE },
      ],
    },
  ];

  return (
    <footer className="bg-[#0f0f0f] text-[#e8e2d6]">
      <div className="container-y px-5 md:px-8 pt-16 pb-10">
        <div className="grid md:grid-cols-4 gap-10 mb-14">
          <div>
            <p className="font-serif-y text-[28px] tracking-[0.35em] text-[#FBF8F4] mb-5">
              YBERA
            </p>
            <p className="font-sans-y text-[13px] leading-relaxed text-[#b5b0a4] mb-6">
              Brazilian hair care crafted in France, loved worldwide. Products designed to care
              for, treat and transform your hair.
            </p>
            <div className="flex items-center gap-4">
              {[Instagram, Facebook, Youtube, Mail].map((Icon, i) => (
                <a
                  key={i}
                  href={aff("/")}
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 border border-[#2a2a2a] flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-sans-y text-[11px] tracking-[0.3em] uppercase text-[#C9A961] mb-5">
                {c.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      target="_blank"
                      rel="noreferrer"
                      className="font-sans-y text-[14px] text-[#b5b0a4] hover:text-[#C9A961] transition-colors"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-[#2a2a2a] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans-y text-[12px] text-[#7a7a7a] text-center md:text-left" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} USA Fashion Hair. Independent authorized Ybera Paris affiliate. Purchases are completed securely on the official Ybera store (ybera.us).
          </p>
          <div className="flex items-center gap-6 shrink-0">
            <Link
              to="/privacy-policy"
              data-testid="footer-privacy-link"
              className="font-sans-y text-[12px] tracking-[0.15em] uppercase text-[#b5b0a4] hover:text-[#C9A961] transition-colors whitespace-nowrap"
            >
              Privacy Policy
            </Link>
            <a
              href={WHATSAPP_AFFILIATE}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 font-sans-y text-[12px] tracking-[0.2em] uppercase text-[#C9A961] hover:text-[#FBF8F4] transition-colors whitespace-nowrap"
            >
              <MessageCircle size={14} /> Talk to us
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
